import { useState, useEffect } from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Button } from '../../components/ui/button';
import { MagnifyingGlass, CheckCircle, Lightning } from '@phosphor-icons/react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('nx_token')}` } });

export default function CreatorContentIntelPage() {
  const [citations, setCitations] = useState(null);
  useEffect(() => { axios.get(`${API}/creator/citation-intel`, auth()).then(r => setCitations(r.data)).catch(() => {}); }, []);

  return (
    <DashboardLayout>
      <div className="space-y-5" data-testid="creator-content-intel">
        <div>
          <h1 className="font-display text-2xl font-black text-[var(--text-primary)] tracking-tight">Content Intelligence</h1>
          <p className="text-sm text-[var(--text-secondary)] mt-1">Which of your posts are being cited by AI — and why</p>
        </div>
        {citations?.linkedin_insight && (
          <div className="nx-metric-card rounded-md border-[var(--accent-border)]">
            <p className="text-[9px] text-[var(--info)] leading-relaxed">{citations.linkedin_insight}</p>
          </div>
        )}
        {citations && (
          <div className="nx-metric-card rounded-md">
            <p className="text-xs text-[var(--text-tertiary)] mb-3">{citations.cited_count}/{citations.total} posts cited by AI</p>
            <div className="space-y-2">
              {citations.posts?.map(p => (
                <div key={p.id} className={`p-3 rounded border ${p.cited ? 'border-[var(--success-border)] bg-[var(--success-bg)]' : 'border-[var(--border)]'}`}>
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-[var(--text-primary)] font-medium">{p.title}</span>
                    <span className="nx-tag nx-tag-blue text-[7px]">{p.platform}</span>
                    {p.ai_crawled && <span className="encrypted-badge">AI Crawled</span>}
                    {p.cited && <CheckCircle size={12} className="text-[var(--success)]" weight="fill" />}
                  </div>
                  <div className="flex gap-1.5 mb-1.5">
                    {Object.entries(p.checks || {}).map(([k, v]) => (
                      <span key={k} className={`px-1.5 py-0.5 text-[8px] rounded font-mono ${v ? 'bg-[var(--success-bg)] text-[var(--success)]' : 'bg-[var(--error-bg)] text-[var(--error)]'}`}>{k.replace(/_/g, ' ')}</span>
                    ))}
                  </div>
                  {p.linkedin_citation_reasons?.length > 0 && (
                    <p className="text-[8px] text-[var(--info)] mt-1">Cited because: {p.linkedin_citation_reasons.join(' / ')}</p>
                  )}
                  {!p.cited && p.suggested_rewrite && (
                    <div className="mt-2 p-2 rounded bg-[var(--accent-light)] border border-[var(--accent-border)]">
                      <p className="text-[9px] text-[var(--text-secondary)]">Suggested rewrite:</p>
                      <p className="text-[10px] text-[var(--text-primary)] italic">{p.suggested_rewrite}</p>
                      <Button size="sm" className="mt-1.5 bg-[var(--accent)] text-white text-[9px] h-6 px-2">Apply Fix</Button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
